import img1 from "../img/project/1.png";
import img2 from "../img/project/2.png";
import img3 from "../img/project/3.png";
import icon1 from "../img/project/icon1.svg";
import icon2 from "../img/project/icon2.svg";
import icon3 from "../img/project/icon3.svg";

export const data = [
	{
		title: "live",
		content: [
			{
				img: img3,
				icon: icon3,
				name: "Polkapet world",
				subname: "$PETS",
				link: "#",
				total_raised: "$300,000",
				starts_on: "January 17th 2022, 13:00 UTC",
			},
			{
				img: img1,
				icon: icon1,
				name: "Polkapet world",
				subname: "$DXP",
				link: "#",
				total_raised: "500/1,000,000 ALGO",
				starts_on: "February 01st 2023, 21:00 UTC",
			},
			{
				img: img2,
				icon: icon2,
				name: "Dexpools",
				subname: "$PETS",
				link: "#",
				total_raised: "$1,500,000",
				starts_on: "January 12th 2022, 13:00 UTC",
			},
		],
	},
	{
		title: "upcoming",
		content: [
			{
				img: img1,
				icon: icon1,
				name: "Polkapet world",
				subname: "$DXP",
				link: "#",
				total_raised: "500/1,000,000 ALGO",
				starts_on: "February 01st 2023, 21:00 UTC",
			},
			{
				img: img2,
				icon: icon2,
				name: "Dexpools",
				subname: "$PETS",
				link: "#",
				total_raised: "$1,500,000",
				starts_on: "January 12th 2022, 13:00 UTC",
			},
			{
				img: img3,
				icon: icon3,
				name: "Polkapet world",
				subname: "$PETS",
				link: "#",
				total_raised: "$300,000",
				starts_on: "January 17th 2022, 13:00 UTC",
			},
		],
	},
	{
		title: "completed",
		content: [
			{
				img: img2,
				icon: icon2,
				name: "Dexpools",
				subname: "$PETS",
				link: "#",
				total_raised: "$1,500,000",
				starts_on: "January 12th 2022, 13:00 UTC",
			},
			{
				img: img1,
				icon: icon1,
				name: "Polkapet world",
				subname: "$DXP",
				link: "#",
				total_raised: "500/1,000,000 ALGO",
				starts_on: "February 01st 2023, 21:00 UTC",
			},
			{
				img: img3,
				icon: icon3,
				name: "Polkapet world",
				subname: "$PETS",
				link: "#",
				total_raised: "$300,000",
				starts_on: "January 17th 2022, 13:00 UTC",
			},
		],
	},
];
